<template>
  <div>
    <div class="grid gap-x-8 sm:grid-cols-1 md:grid-cols-1">
      <div class="panel">
        <div class="panel-body">
          <liquidation-weekly :data="totals_weekly" title="Monto total" y_label="USD" :formatter="currency_formatter" />
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <crop-size-weekly :data="crop_size_weekly" :crop_size_labels="crop_size_labels" title="Costo FOB Caja x Calibre" y_label="USD" :formatter="currency_formatter" />
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <crop-size-earning-weekly :data="crop_size_earning_weekly" :crop_size_labels="crop_size_labels" title="Ganancia Kg x Calibre" y_label="USD" :formatter="currency_formatter" />
        </div>
      </div>
      <crop-size-weekly-table :data="crop_size_weekly" :crop_size_labels="crop_size_labels" />
    </div>
  </div>
</template>

<script>
import CropSizeEarningWeekly from "@/components/views/agro_exporter/liquidations/query_by_provider/charts/CropSizeEarningWeekly.vue";
import CropSizeWeekly from "@/components/views/agro_exporter/liquidations/query_by_provider/charts/CropSizeWeekly.vue";
import CropSizeWeeklyTable from "@/components/views/agro_exporter/liquidations/query_by_provider/charts/CropSizeWeeklyTable.vue";
import LiquidationWeekly from "@/components/views/agro_exporter/liquidations/query_by_provider/charts/LiquidationWeekly.vue";
export default {
  name: "AELiquidationsQueryByProviderShowProviderWeekly",
  components: {
    CropSizeEarningWeekly,
    CropSizeWeekly,
    CropSizeWeeklyTable,
    LiquidationWeekly,
  },
  props: {
    provider_id: { required: true },
    provider_type: { required: true },
    agro_exporter_process_id: { required: true },
    totals_weekly: { required: true },
    crop_size_labels: { required: true },
    crop_size_weekly: { required: true },
    crop_size_earning_weekly: { required: true }
  },
  data() {
    return {};
  },
  methods: {
    currency_formatter: function (val) {
      if(Number(val)) return `$ ${this.numberWithPrecision(val)}`;
      return "";
    },
  },
};
</script>
